import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useProfile } from "@/context/ProfileContext";
import { UserAvatar } from "@/components/ui-nw/UserAvatar";
import { errorMessage } from "@/lib/api";
import { PROFILE } from "@/constants/testIds";

export const AvatarUploader = () => {
  const { profile, request, apply } = useProfile();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("Image must be under 5 MB");
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try { apply(await request("post", "/me/avatar", fd)); toast.success("Profile picture updated"); }
    catch (err) { toast.error(errorMessage(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="relative">
      <UserAvatar profile={profile} size="h-28 w-28 sm:h-32 sm:w-32" textSize="text-3xl" testId={PROFILE.avatar} />
      <button type="button" data-testid={PROFILE.avatarButton} onClick={() => input.current?.click()} disabled={busy}
        className="absolute bottom-1 right-1 grid h-9 w-9 place-items-center rounded-full bg-nw-red text-white shadow-[0_0_15px_rgba(255,30,39,0.6)] ring-2 ring-nw-bg transition-transform duration-200 hover:scale-110 disabled:opacity-70"
        aria-label="Change profile picture">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Camera className="h-4 w-4" />}
      </button>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp,image/gif" hidden data-testid={PROFILE.avatarInput} onChange={onFile} />
    </div>
  );
};
